import { AgxSpacer, AgxTypography, Icon_CheckmarkCircleOutline } from '@urbanx/agx.ui-components2';
import './BlankContractProgress.scss';
import { BlankContractProgressModel } from '@urbanx/agx.campaigns.client';
import { renderProgress } from './BlankContractProgress.helpers';
import { CircularProgressIndicator } from './CircularProgressIndicator';
import { Fragment } from 'react';

interface BlankContractProgressProps {
  blankContractProgress: BlankContractProgressModel;
}

const BlankContractProgress = ({ blankContractProgress }: BlankContractProgressProps) => {
  const detailProgress = blankContractProgress.details!;
  const completedSteps =
    detailProgress.filter(({ complete }) => complete).length +
    Number(blankContractProgress.finalisingContract!);
  const totalSteps = detailProgress.length + 1;

  return (
    <AgxSpacer fill contentAlignment="center" gap="md">
      <AgxSpacer fill contentAlignment="center" padding="md" gap="md">
        {blankContractProgress.finalisingContract ? (
          <>
            <Icon_CheckmarkCircleOutline
              color="var(--fg-success, var(--ui-success))"
              width={44}
              height={45}
            />
            <AgxTypography id="age-blank-contract-ready" type="body" size="medium">
              Blank Contract is ready
            </AgxTypography>
          </>
        ) : (
          <>
            <CircularProgressIndicator
              currentSteps={completedSteps}
              totalSteps={totalSteps}
              width={60}
              height={60}
            />
            <AgxTypography id="balnk-contract-in-progress" type="body" size="medium">
              Blank Contract preparation in progress
            </AgxTypography>
          </>
        )}
      </AgxSpacer>

      {!blankContractProgress.finalisingContract && (
        <AgxSpacer fill direction="vertical" className="blankContractPreparationBody">
          {detailProgress.map(({ label, complete }) => (
            <Fragment key={label}>{renderProgress(label!, complete!)}</Fragment>
          ))}
          {renderProgress('Finalising contract', blankContractProgress.finalisingContract!)}
        </AgxSpacer>
      )}
    </AgxSpacer>
  );
};

export default BlankContractProgress;
